const generalStrings = {
  notFound: {
    title: 'You went off limits here',
    subTitle: 'Click header logo to continue browsing',
  },
};

export default generalStrings;
